import { useRecordContext } from "react-admin";
import ApproveModal from "components/CareerCenter/Partials/ApproveModal";
import { careerCenterRequests } from "api/careerCenterApi";

const ApproveJob = () => {
  const record = useRecordContext();

  return (
    <ApproveModal
      title="Одобри"
      titleContent="Сигурен ли сте, че искате да одобрите тaзи обява за работа?"
      request={careerCenterRequests.approveJobOffer(record?.id)}
      successMessage="Успешно одобрена обява за работа"
    />
  );
};

export default ApproveJob;
